import { render, staticRenderFns } from "./NoticeSet.vue?vue&type=template&id=82e975ce&scoped=true"
import script from "./NoticeSet.vue?vue&type=script&lang=js"
export * from "./NoticeSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e975ce",
  null
  
)

export default component.exports